import { environment } from '../../environments/environment';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export function initGoogleAnalytics(): void {
  const id = environment.gaMeasurementId;
  if (!id) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', id, { send_page_view: false });
}

export function trackGoogleAnalyticsPageView(
  path: string,
  title: string,
  locationHref: string
): void {
  window.gtag?.('event', 'page_view', {
    page_path: path,
    page_title: title,
    page_location: locationHref,
  });
}

export function trackGoogleAnalyticsEvent(
  name: string,
  params?: Record<string, unknown>
): void {
  window.gtag?.('event', name, params);
}
